import { mapLeaderboard } from "db/mapping/leaderboard/FsLeaderboard";
import { FsLeaderboard } from "db/model/leaderboard/FsLeaderboard";
import { db } from "firebase-config";
import { onSnapshot, collection } from "firebase/firestore";
import { updateLeaderboards } from "app/slices/LeaderboardSlice";
import { store } from "app/store";
import { nonUndefined } from "Utility";
import { leaderboardCollectionName } from "./collectionNames";

export const setupLeaderboardSnapshot = () => {
  onSnapshot(collection(db, leaderboardCollectionName), (querySnapshot) => {
    const leaderboards = nonUndefined(
      querySnapshot
        .docChanges()
        .map((d) => mapLeaderboard(d.doc.data() as FsLeaderboard, d.doc.id))
    );

    store.dispatch(
      updateLeaderboards({
        leaderboards,
      })
    );
  });
};
